import View from './view';
export const PollVoteResultItem = View;
